/** @jsxImportSource @emotion/react */
import { createStyles } from '@quickbit/qb-design-system';
import { ReactNode } from 'react';
import { useOutlet } from 'react-router-dom';

interface Props {
  children?: ReactNode;
}

export const PublicRouteLayout = ({ children }: Props) => {
  const outlet = useOutlet();
  const styles = useStyles();
  return <main css={styles.main}>{outlet ?? children}</main>;
};

const useStyles = createStyles(({ spacing }) => ({
  main: {
    display: 'flex',
    maxWidth: '1440px',
    width: '100%',
    marginRight: 'auto',
    marginLeft: 'auto',
    height: '100%',
    minHeight: '100vh',
    padding: spacing.xxs,
  },
}));
